module.exports = __webpack_public_path__ + "img/addtohome.b895a65c.jpg";